import { useCallback, useEffect, useState } from "react";
import { Card, CardBody, Col, Row, TabContent, TabPane } from "reactstrap";
import { Contacts, Personal } from "../../../../../constants";
import { useAppSelector } from "../../../../../reduxToolkit/hooks";
import { PersonalTabProp, UserCallback, UpdateUserItems } from "../../../../../types/Applications";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";
import { UpdateContactForm } from "./updateContactForm";
import ContactDetails from "./contactDetails";
import ContactList from "./ContactList";

// This component displays a list of users and their contact details, allowing selection and editing of user information.
const PersonalTab: React.FC<PersonalTabProp> = ({ historyToggle }) => {
  const { users } = useAppSelector((state) => state.contact);
  const [selectedUser, setSelectedUser] = useState<undefined | UserCallback | UpdateUserItems>();
  const [editing, setEditing] = useState(false);
  const [editData, setEditData] = useState({});

  const userCallback = useCallback((user: UserCallback) => setSelectedUser(user), []);
  const userEditCallback = useCallback((edit: boolean, usersData: UpdateUserItems) => {
    setEditData(usersData);
    setSelectedUser(usersData);
    setEditing(edit);
  }, []);

  // Automatically selects the first user in the list when users change
  useEffect(() => setSelectedUser(users[0]), [users]);

  return (
    <Card className="mb-0">
      <CommonCardHeader headClass="d-flex" title={Personal} span={[{ text: `${users.length} ${Contacts}` }]} />
      <CardBody className="p-0">
        <Row className="list-persons">
          <ContactList users={users} userCallback={userCallback} selectedUser={selectedUser ? selectedUser : users[0]} />
          <Col xl="8" md="7" className="xl-50">
            {editing ? (
              <UpdateContactForm editData={editData} userEditCallback={userEditCallback} />
            ) : (
              <TabContent activeTab={0}>
                <TabPane className="tab-content-child" tabId={0}>
                  <ContactDetails historyToggle={historyToggle} selectedUser={selectedUser ? selectedUser : users[0]} userEditCallback={userEditCallback} />
                </TabPane>
              </TabContent>
            )}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
export default PersonalTab;
